import { useCallback } from 'react';

import { useAmplitude } from '@crehana/analytics';

const useRenderContentDetailEventAmplitude = () => {
  const { logEvent } = useAmplitude();

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentionally managed
  const setEventAmplitud = useCallback(
    (
      queryParams: string | undefined,
      idContent: string,
      titleContent: string,
    ) => {
      const parseData = JSON.parse(queryParams ?? '{}');
      const directSource = document.referrer;
      const params = !directSource ? { Source: 'Direct' } : { ...parseData };

      logEvent({
        event: 'Render Content Detail',
        data: {
          ...params,
          'Content ID': idContent,
          'Content Name': titleContent,
        },
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return { setEventAmplitud };
};

export default useRenderContentDetailEventAmplitude;
